export default "__VITE_ASSET__BNblTjxc__"